import moment from "moment/moment";

export default function truncate (string, value) {
  if(string && string.length > value){
    return string.substring(0, value) + '...';
  } else {
    return string;
  }
}


// WEBPACK FOOTER //
// ./src/app/filters/truncate.js